import React, { useState } from 'react';
import Header from "../Components/Header";
import FormationCard from '../Components/FormationCard';
import ArticleViewer from '../Components/ArticleViewer';
import MyLoader from '../Components/Loader';

const GetArticleView = (formationsData, article, loading) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    console.log(article);

    // Function to go to the previous image
    const prevSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? article.images.length - 1 : prevIndex - 1
        );
    };

    // Function to go to the next image
    const nextSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === article.images.length - 1 ? 0 : prevIndex + 1
        );
    };

    return (
        <>
            {loading ? (
                <Header title={"Article"} />
            ) : (<Header title={article.title || "Article"} image={`https://backsc.osc-fr1.scalingo.io${article.images[0]}`} />
            )}

            <div className="ficheblog">
                <ArticleViewer article={article} loading={loading} />
                <section className="autres-formations">
                    <h2 className="section-title">Autres Formations</h2>
                    <div className="row">
                        {loading ? (
                            MyLoader()
                        ) : (
                            formationsData.map((formation, index) => (
                                <a href={"/formation/" + formation.id} className="col-md-4 mb-4">
                                    <div key={index}>
                                        <div className="card ssip3-card">
                                            {formation.training_cycle.id === 1 ? (
                                                <img src={'https://cdn.builder.io/api/v1/image/assets/TEMP/25af45e77d6bdad6be0823e485e1185dbcade06700e334c8679be0e3beea81f8?apiKey=59156c16963f46e28d2e0d857e2bfa45&'} alt={formation.name} className="course-image" />
                                            ) : formation.training_cycle.id === 2 ? (
                                                <img src={'https://cdn.builder.io/api/v1/image/assets/TEMP/a0a73d9596425af046d195ca798473528c2f8d418be124f00087b8b935102ee7?apiKey=59156c16963f46e28d2e0d857e2bfa45&'} alt={formation.name} className="course-image" />
                                            ) : (<img src={'https://cdn.builder.io/api/v1/image/assets/TEMP/ad826d4b70d96ec1d03af674552d8991a3c18ddf6c062a52ef99778dc6fc8a99?apiKey=59156c16963f46e28d2e0d857e2bfa45&'} alt={formation.name} className="course-image" />)}
                                            <div className="card-body text-center">
                                                <div className="ssip3-overlay">
                                                    <h1 className="ssip3-title">{formation.name}</h1>
                                                </div>
                                                {formation.training_cycle.id === 1 ? (
                                                    <div className="ssip3-tag">Incendie</div>
                                                ) : formation.training_cycle.id === 2 ? (
                                                    <div className="ssip3-tag-2">Secourisme</div>
                                                ) : (<div className="ssip3-tag-3">Prévention des risques</div>)}
                                            </div>
                                        </div>
                                    </div></a>
                            )))}
                    </div>
                    <a href="#" className="voir-toutes">Voir toutes les formations &gt;</a>
                </section></div>
        </>
    );
};

export default GetArticleView;
